import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import selectors from '../selectors';
import entryActions from '../entry-actions';
import UserManagementModal from '../components/UserManagementModal';

const mapStateToProps = (state) => {
  const users = selectors.selectUsersForCurrentOrganization(state);
  const oidcConfig = selectors.selectOidcConfig(state);
  const currentUser = selectors.selectCurrentUser(state);

  return {
    isOpen: true, // Siempre abierto cuando se monta
    users: users,
    canAddUsers: !oidcConfig || !oidcConfig.isEnforced,
    organizationId: currentUser ? currentUser.organizationId : null,
  };
};

const mapDispatchToProps = (dispatch) => {
  const actions = bindActionCreators(
    {
      onClose: entryActions.closeModal,
      onUserUpdate: entryActions.updateUser,
      onUserUsernameUpdate: entryActions.updateUserUsername,
      onUserUsernameUpdateMessageDismiss: entryActions.clearUserUsernameUpdateError,
      onUserEmailUpdate: entryActions.updateUserEmail,
      onUserEmailUpdateMessageDismiss: entryActions.clearUserEmailUpdateError,
      onUserPasswordUpdate: entryActions.updateUserPassword,
      onUserPasswordUpdateMessageDismiss: entryActions.clearUserPasswordUpdateError,
      onUserDelete: entryActions.deleteUser,
      syncOrganizationFromClerk: entryActions.syncOrganizationFromClerk,
    },
    dispatch,
  );

  return {
    ...actions,
    onSyncFromClerk: (organizationId) => actions.syncOrganizationFromClerk(organizationId),
  };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps,
  onSyncFromClerk: () => dispatchProps.onSyncFromClerk(stateProps.organizationId),
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(UserManagementModal);
